import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=1d81e2c0&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=1d81e2c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d81e2c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d81e2c0')) {
      api.createRecord('1d81e2c0', component.options)
    } else {
      api.reload('1d81e2c0', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=1d81e2c0&scoped=true&", function () {
      api.rerender('1d81e2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard.vue"
export default component.exports